<template>
  <div id="settings-wrapper">
    <v-row>
      <v-card
        id="settings"
        class="py-2 px-4"
        color="rgba(0, 0, 0, .3)"
        dark
        flat
        link
        min-width="80"
        style="position: fixed; top: 115px; right: 0px; border-top-left-radius: 8px; border-bottom-left-radius: 8px;"
      >
        <!-- <v-icon
          large
          style="-webkit-animation:spin 4s linear infinite;
    -moz-animation:spin 4s linear infinite;
    animation:spin 4s linear infinite;"
        >mdi-settings</v-icon>-->
        <v-icon large>mdi-settings</v-icon>
      </v-card>
    </v-row>
    <v-row>
      <v-menu
        :close-on-content-click="false"
        activator="#settings"
        bottom
        content-class="v-settings"
        left
        nudge-left="8"
        offset-x
        origin="top right"
        transition="scale-transition"
        z-index="15"
        max-height="90%"
      >
        <v-card class="mb-0" width="600">
          <personalization></personalization>
        </v-card>
      </v-menu>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "DashboardCoreSettings",
  components: {
    personalization: () => import("@/components/personalization")
  }
};
</script>

<style>
@-moz-keyframes spin {
  100% {
    -moz-transform: rotate(360deg);
  }
}
@-webkit-keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
  }
}
@keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
